<template>
  <div class="app">
    <router-view />
  </div>
</template>

<style lang="scss" scoped>
.app {
  width: 100%;
  height: 100%;
  background: linear-gradient( 180deg, #060C21 0%, #001A40 100%);
  position:relative;
  overflow: hidden;
}
</style>
